import React from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_URLS } from "../../helpers/constants";
import {
  commonSiteCoreAccessDeniedLabelKeys,
  commonSiteCoreKeys,
} from "../../helpers/constants/siteCoreKeys";
import { getValueOrBlank } from "../../helpers/utils";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { MuiButtonSecondary } from "../button/MuiButton";
import { MuiTypography } from "../typography/MuiTypography";
import { AccessDeniedWrapper } from "./AccessDenied.style";

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToDashboard = (): void => {
    navigate(PAGE_URLS.DASHBOARD);
  };

  const { commonAccessDeniedDetails, fetchMediaListImage } =
    useNavigationSiteCore();

  const accessDeniedImage = fetchMediaListImage(
    commonSiteCoreAccessDeniedLabelKeys.accessDeniedParentKey,
    commonSiteCoreAccessDeniedLabelKeys.accessDeniedImage,
    commonSiteCoreKeys.smallImage,
  );

  const accessDeniedTitle = getValueOrBlank(
    commonAccessDeniedDetails.accessDeniedTitle,
  );
  const accessDeniedSubTitle = getValueOrBlank(
    commonAccessDeniedDetails.accessDeniedDescription,
  );
  const backToDashboardButton = getValueOrBlank(
    commonAccessDeniedDetails.backToDashboardButton,
  );
  return (
    <AccessDeniedWrapper>
      <img
        src={accessDeniedImage?.ImageUrl}
        alt={accessDeniedImage?.AltText}
        loading="lazy"
        decoding="async"
        className="image"
      />
      <MuiTypography className="header" component="label" variant="h1Bold">
        {accessDeniedTitle}
      </MuiTypography>
      <MuiTypography className="subheader" component="label" variant="h3">
        {accessDeniedSubTitle}
      </MuiTypography>
      <MuiButtonSecondary
        className="go-to-dashboard-button"
        onClick={handleNavigateToDashboard}
        id={"access-denied-go-to-dashboard-button"}
      >
        {backToDashboardButton}
      </MuiButtonSecondary>
    </AccessDeniedWrapper>
  );
};

export default AccessDenied;
